import { useMemo } from 'react'

type DocumentNode = {
  id: string
  documentType: string
  documentId?: string | null
  documentFilename?: string | null
  signatureStatus?: string | null
}

type GroupedDocument = DocumentNode & {
  _groupedCount: number
  _isGrouped: boolean
}

export const useGroupedDocumentsByEmployee = (
  documents: DocumentNode[] | undefined
): GroupedDocument[] => {
  return useMemo(() => {
    if (!documents || documents.length === 0) {
      return []
    }

    const groups = new Map<string, DocumentNode[]>()

    documents.forEach((doc) => {
      const isAssignOrUnassign = doc.documentType === 'assign' || doc.documentType === 'unassign'

      if (isAssignOrUnassign) {
        const groupKey = `draft-${doc.documentType}-${doc.documentId ?? ''}`
        const existingGroup = groups.get(groupKey)
        if (!existingGroup) {
          groups.set(groupKey, [])
        }
        const currentGroup = groups.get(groupKey)
        if (currentGroup) {
          currentGroup.push(doc)
        }
      } else {
        const individualKey = `individual-${doc.id}`
        groups.set(individualKey, [doc])
      }
    })

    const result: GroupedDocument[] = []

    for (const groupDocs of groups.values()) {
      const representative = groupDocs[0]
      if (!representative) {
        continue
      }

      result.push({
        id: representative.id,
        documentType: representative.documentType,
        documentId: representative.documentId,
        documentFilename: representative.documentFilename,
        signatureStatus: representative.signatureStatus,
        _groupedCount: groupDocs.length,
        _isGrouped: groupDocs.length > 1,
      })
    }

    return result
  }, [documents])
}
